import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

const getToken = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  return user?.data?.token || null;
};

const getAuthHeaders = () => {
  const token = getToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

const getBanners = async () => {
  const response = await axios.get(`${base_url}banner/all`, getAuthHeaders());

  return response.data;
};
// const createBanner = async (banner) => {
//   const response = await axios.post(`${base_url}banner/add`, banner, config);

//   return response.data;
// };

// const createBanner = async (banner) => {
//   const response = await axios.post(
//     `${base_url}banner/add`,
//     {
//       banner_name: banner.banner_name,
//       banner_image: banner.banner_image, // Base64 image string
//     },
//     config
//   );

//   return response.data;
// };

const createBanner = async (banner) => {
  const token = getToken();
  const response = await axios.post(
    `${base_url}banner/add`,
    banner, // `banner` is already a FormData object
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};


const getABanner = async (id) => {
  const response = await axios.get(`${base_url}banner/get/${id}`, getAuthHeaders());

  return response.data;
};

const deleteBanner = async (id) => {
  const response = await axios.delete(`${base_url}banner/delete/${id}`, getAuthHeaders());

  return response.data;
};
// const updateBanner = async (banner) => {
//   console.log(banner);
//   console.log(`${base_url}banner/update/${banner.id}`)
//   const response = await axios.put(
//     `${base_url}banner/update/${banner.id}`,
//     { banner_name: banner.pCatData.banner_name },
//     config
//   );
//   return response.data;
// };

// const updateBanner = async (banner) => {
//   const formData = new FormData();
//   formData.append("banner_name", banner.pCatData.banner_name);

//   // Check if `banner_image` is a file or a string (existing image path)
//   if (banner.pCatData.banner_image instanceof File) {
//     formData.append("banner_image", banner.pCatData.banner_image); // Append file
//   } else {
//     formData.append("banner_image", banner.pCatData.banner_image); // Append existing path
//   }

//   const response = await axios.put(
//     `${base_url}banner/update/${banner.id}`,
//     formData,
//     {
//       headers: {
//         "Content-Type": "multipart/form-data", // ✅ Required for FormData
//       },
//     }
//   );

//   return response.data;
// };


// const updateBanner = async (banner) => {
//   const response = await axios.put(
//     `${base_url}banner/update/${banner.id}`,
//     {
//       banner_name: banner.pCatData.banner_name,
//       banner_image: banner.pCatData.banner_image, // Base64 image string
//     },
//     config
//   );
//   return response.data;
// };

const updateBanner = async (banner) => {
  const token = getToken();
  const response = await axios.put(
    `${base_url}banner/update/${banner.id}`,
    banner.bannerData, // Ensure this is FormData
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};


// const updateBanner = async (banner) => {
//   const response = await axios.put(
//     `${base_url}banner/update/${banner.id}`,
//     banner.pCatData, // FormData object
//     {
//       headers: {
//         "Content-Type": "multipart/form-data", // ✅ Required for FormData
//       },
//     }
//   );
//   return response.data;
// };

// const updateBanner = async (banner) => {
//   const response = await axios.put(
//     `${base_url}banner/update/${banner.id}`,
//     banner.pCatData, 
//     {
//       headers: {
//         "Content-Type": "multipart/form-data", // ✅ Ensure FormData is sent
//       },
//     }
//   );
//   return response.data;
// };

const bannerService = {
  getBanners,
  createBanner,
  getABanner,
  deleteBanner,
  updateBanner,
};

export default bannerService;
